import { ref, reactive, watch } from 'vue'
import { defineStore } from 'pinia'

export const useThemeStore = defineStore('theme', () => {
  const currentTheme = ref(localStorage.getItem('theme') || 'light')

  const themeColors = reactive({
    colorText: '',
    colorBackground: '',
    colorVidacorp: '',
    colorVidacorpDark: '',
    colorArrotex: '',
    colorArrotexDark: '',
    colorWhite: '',
    colorMute: '',
    colorBackgroundBright: '',
  })

  function updateThemeColors() {
    const rootStyle = getComputedStyle(document.documentElement)
    themeColors.colorText = rootStyle.getPropertyValue('--color-text').trim()
    themeColors.colorBackground = rootStyle.getPropertyValue('--color-background').trim()
    themeColors.colorVidacorp = rootStyle.getPropertyValue('--color-vidacorp-3').trim()
    themeColors.colorVidacorpDark = rootStyle.getPropertyValue('--color-vidacorp-1').trim()
    themeColors.colorArrotex = rootStyle.getPropertyValue('--color-arrotex-3').trim()
    themeColors.colorArrotexDark = rootStyle.getPropertyValue('--color-arrotex-1').trim()
    themeColors.colorWhite = rootStyle.getPropertyValue('--color-white').trim()
    themeColors.colorMute = rootStyle.getPropertyValue('--color-mute').trim()
    themeColors.colorBackgroundBright = rootStyle.getPropertyValue('--color-background-bright').trim()
  }

  function setTheme(theme: string) {
    currentTheme.value = theme
    localStorage.setItem('theme', theme)
    document.documentElement.setAttribute('data-theme', theme)
    updateThemeColors()
  }

  watch(currentTheme, updateThemeColors, { immediate: true })

  return {
    currentTheme,
    themeColors,
    setTheme
  }
})
